import { render, staticRenderFns } from "./AlertDeleteDialog.vue?vue&type=template&id=94631bd0&scoped=true"
import script from "./AlertDeleteDialog.vue?vue&type=script&lang=ts"
export * from "./AlertDeleteDialog.vue?vue&type=script&lang=ts"
import style0 from "./AlertDeleteDialog.vue?vue&type=style&index=0&id=94631bd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94631bd0",
  null
  
)

export default component.exports